import { hierarchyPropertyKey } from "components/hierarchypage/HierarchyProperties";
import { eHierarchyLevel } from "./api/enums";

/**
 * Label and message description for the hierarchy tag field, keyed by level.
 */
export interface IHierarchyTagInfo {
  /** Label displayed in the modal input field. */
  label: string;
  /** Description used in validation error messages. */
  description: string;
  /** Property key used when constructing hierarchy tag properties. */
  key: hierarchyPropertyKey;
  /** Validation message shown when the tag format is invalid. */
  validationText: string;
}

/**
 * Returns the label and description for the hierarchy tag field based on hierarchy level.
 *
 * @param level - Hierarchy level used to resolve level-specific tag labels.
 * @returns Tag label and description for validation and modal text.
 */
export const getHierarchyTagFieldInfo = (level?: eHierarchyLevel): IHierarchyTagInfo => {
  switch (level) {
    case eHierarchyLevel.Corporate:
      return {
        label: "Corporate tag",
        description: "corporate tag",
        key: "hierarchyTag",
        validationText: "",
      };
    case eHierarchyLevel.TA:
      return {
        label: "TA prefix",
        description: "TA prefix",
        key: "taPrefix",
        validationText: "Prefix must be 2 or 3 upper case characters",
      };
    case eHierarchyLevel.Project:
      return {
        label: "Project code",
        description: "project code",
        key: "projectCode",
        validationText: "Project code must begin with D followed by 3 digits",
      };
    case eHierarchyLevel.Study:
      return {
        label: "D number",
        description: "D number",
        key: "dNumber",
        validationText: "Field should be D followed by 10 characters",
      };
    case eHierarchyLevel.Report:
      return {
        label: "Report tag",
        description: "report tag",
        key: "hierarchyTag",
        validationText: "",
      };
    default:
      return {
        label: "Hierarchy tag",
        description: "hierarchy tag",
        key: "hierarchyTag",
        validationText: "",
      };
  }
};
